module.exports = __webpack_public_path__ + "img/th old.5fd4b8d5.png";